import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Landings } from 'src/pages/Landings';
import { NavBarLayout } from 'src/components/templates/NavBarLayout';
import { CurrentAuthState, useAuthContext } from 'src/contexts/AuthContext';
import { AppRoutes } from './routes';
import { DataIntegration } from 'src/pages/DataIntegration';
import { CustomerSettingsContextProvider } from 'src/contexts/CustomerSettingsContext/CustomerSettingsContextProvider';
import { FilterContextProvider } from 'src/contexts/FilterContext/FilterContextProvider';
import { DataLoading } from 'src/components/molecules/DataStatusWrapper/DataLoading';
import { useAppContext } from 'src/contexts/AppContext/index';

export function App() {
  const { userProfile, currentAuthState, refreshAuthState } = useAuthContext();
  const { currentCustomer, customersList } = useAppContext();

  /**
   * Make sure the context is kept in sync -
   * whenever the app is reloaded, refresh
   * the authentication state.
   */
  useEffect(() => {
    refreshAuthState();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Avoid rendering flicker while auth state initializes
  if (
    currentAuthState === CurrentAuthState.Loading ||
    customersList.isLoading
  ) {
    return <DataLoading />;
  }

  return currentAuthState === CurrentAuthState.SignedIn &&
    userProfile?.email ? (
    currentCustomer?.isRegistrationStarted ? (
      <DataIntegration />
    ) : (
      <div className="App">
        <BrowserRouter>
          <CustomerSettingsContextProvider>
            <FilterContextProvider>
              <NavBarLayout>
                <AppRoutes />
              </NavBarLayout>
            </FilterContextProvider>
          </CustomerSettingsContextProvider>
        </BrowserRouter>
      </div>
    )
  ) : (
    <Landings />
  );
}
